import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '@/lib/axios'
import { KpiWidget } from './KpiWidget'

export function KpiRdaDaOrdinareWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<number>({
    queryKey: ['dashboard', 'rda-da-ordinare-count'],
    queryFn: async () => {
      const res = await axiosInstance.get('/purchase-requests/count', {
        params: { stato_nome: 'Approvata' },
      })
      return res.data?.count ?? 0
    },
    staleTime: 30000,
  })
  return (
    <KpiWidget
      title="RDA da ordinare"
      value={data}
      loading={isLoading}
      color={data ? '#1677ff' : '#52c41a'}
      onClick={() => navigate('/rda?stato_nome=Approvata')}
    />
  )
}
